/* eslint-disable linebreak-style */
import React from 'react';
import PropTypes from 'prop-types';
import Col from 'base-ui/dist/Col';
import Row from 'base-ui/dist/Row';
import NavLink from 'components/NavLink';

const getConfig = require('next/config').default;

const { publicRuntimeConfig = {} } = getConfig ? getConfig() : {};

const MoreTopicsWidget = ({ widget }) => (
  <section id="more-topics-list-widget" className="widget">
    <div className="section-title transparent-border">
      <span className="label text-uppercase titles-color">{widget.options.title}</span>
    </div>
    <Row>
      {widget.content.map((category) => (
        <Col key={category.title} xs="12" sm="4" className="list-col">
          <div className="section-title main-border">
            <span className="label main-color">{category.title}</span>
          </div>
          {category.posts.map((post) => (
            <NavLink
              basePath={publicRuntimeConfig.PUBLIC_URL}
              key={post.id}
              as={`${post?.permalink}`}
              to={`/article?permalink=${post.permalink}`}
              routerStrategy={'next'}
            >
              {post.title}
            </NavLink>
          ))}
        </Col>
      ))}
    </Row>
  </section>
);

MoreTopicsWidget.propTypes = {
  widget: PropTypes.object,
};

export default MoreTopicsWidget;
